module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Regular.1d98d61.woff2";